"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    permissionId: zod_1.z.string(),
});
exports.path = '/admin-delete-permission';
//# sourceMappingURL=index.js.map